<div
  id="general-details"
  class="col">
  <div
    id="tool-location"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "toolinfo.location" | translate }}
      <button
        *ngIf="authService.user?.allowEditTool"
        (click)="openLocationModal()"
        class="button--sm button-primary">
        <fa-icon [icon]="faPencilAlt"></fa-icon>
        <span class="button__label"> {{ "button.edit" | translate }}</span>
      </button>
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.locationname" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ tool.locationName
              }}{{ tool.locationDescription ? " : " + tool.locationDescription : "" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    id="tool-department"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "toolinfo.department" | translate }}
      <button
        *ngIf="authService.user?.allowEditTool"
        (click)="openDepartmentModal()"
        class="button--sm button-primary">
        <fa-icon [icon]="faPencilAlt"></fa-icon>
        <span class="button__label"> {{ "button.edit" | translate }}</span>
      </button>
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.departmentname" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.department }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    id="tool-service"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "toolinfo.service" | translate }}
      <button
        *ngIf="authService.user?.allowEditTool"
        (click)="openServiceModal()"
        type="button"
        class="button--sm button-primary">
        <fa-icon [icon]="faPencilAlt"></fa-icon>
        <span class="button__label"> {{ "button.edit" | translate }}</span>
      </button>
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.nextservice" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ serviceSchedule.nextDate | date }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.lastservice" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ serviceSchedule.lastDate | date }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.serviceinterval" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ serviceSchedule.frequency }}
              {{ serviceSchedule.localizedInterval | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    id="tool-calibration"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "toolinfo.calibration" | translate }}
      <button
        *ngIf="authService.user?.allowEditTool"
        (click)="openCalibrationModal()"
        type="button"
        class="button--sm button-primary">
        <fa-icon [icon]="faPencilAlt"></fa-icon>
        <span class="button__label"> {{ "button.edit" | translate }}</span>
      </button>
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.nextcalibration" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ calibrationSchedule.nextDate | date }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.lastcalibration" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ calibrationSchedule.lastDate | date }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.calibrationinterval" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ calibrationSchedule.frequency }}
              {{ calibrationSchedule.localizedInterval | translate }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.calibrationstatus" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ calibrationStatusLabel }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.certificatenumber" | translate }}
            </td>
            <td class="o-tech-table__description">
              <download-file
                *ngIf="certificate"
                [file]="certificate"></download-file>
            </td>
          </tr>
          <!-- TODO: certificate type doesn't have a meaningful value for now
          once the value well be set correctly in the process (callibrator, SPIRIT),
          then it will be visible here to. -->
          <!-- <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "toolinfo.certificatetype" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ calibrationSchedule.certificateType }}
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>
  <div
    *ngIf="!authService.user?.allowEditTool"
    id="tool-active"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row">
      {{ "toolinfo.active" | translate }}
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ tool.isActive ? "Yes" : "No" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    id="tool-other-info"
    class="bg-white u-shadow">
    <div class="o-tech-table__header">
      {{ "toolinfo.additionalinformation" | translate }}
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.subtype" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.subtype }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.articlenumber" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.articleNumber }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.manufacturer" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.manufacturer }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.vendor" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.vendor }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.purhcasedate" | translate }}
            </td>
            <td class="o-tech-table__description">
              {{ tool.purchaseDate | date }}
            </td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.contact" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.contact }}</td>
          </tr>
          <tr class="o-tech-table__item">
            <td
              scope="row"
              class="o-tech-table__title">
              {{ "tool.contactemail" | translate }}
            </td>
            <td class="o-tech-table__description">{{ tool.contactEmail }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    id="tool-notes"
    class="bg-white u-shadow">
    <div class="o-tech-table__header row between">
      {{ "toolinfo.notes" | translate }}
      <button
        *ngIf="authService.user?.allowEditTool"
        (click)="openNotesModal()"
        type="button"
        class="button--sm button-primary">
        <fa-icon [icon]="faPencilAlt"></fa-icon>
        <span class="button__label"> {{ "button.edit" | translate }}</span>
      </button>
    </div>
    <div class="o-tech-table__container">
      <table class="o-tech-table">
        <tbody>
          <tr class="o-tech-table__item">
            <td class="o-tech-table__full-width">
              <div
                *ngIf="tool.notes"
                class="preformatted">
                {{ tool.notes }}
              </div>
              <div *ngIf="!tool.notes">&nbsp;</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
